import { schema } from 'normalizr';

export const voteSchema = new schema.Entity('vote');
